import { render, staticRenderFns } from "./ListItemExpandable.vue?vue&type=template&id=b577b444&scoped=true"
import script from "./ListItemExpandable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListItemExpandable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListItemExpandable.vue?vue&type=style&index=0&id=b577b444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b577b444",
  null
  
)

export default component.exports